import { useMutation } from "@tanstack/react-query";
import { Button, message } from "antd";
import { FormattedMessage, useIntl } from "react-intl";
import { deleteLoyaltyProgram } from "../../../network/settings";
import queryClient from "../../../services/react-query/queryClient";

const ConFirmDeleteProgram = ({ close, isModalDeleteOpen }: any) => {
  const intl = useIntl();
  const { mutate: DeleteProgram, isLoading } = useMutation(
    deleteLoyaltyProgram,
    {
      onSuccess: (res: any) => {
        if (res?.code === "ERR_BAD_REQUEST") {
          message.error(res?.response?.data?.message);
        } else {
          message.success("loyalty Deleted");
          queryClient.invalidateQueries(["loyalty"]);
          close();
        }
      },
    }
  );
  return (
    <div className="flex flex-col items-center justify-center w-full gap-8 px-8 pt-6 pb-6 mt-8 bg-white rounded-lg">
      <span className="text-lg font-semibold">
        <FormattedMessage id="confirm.delete" />
      </span>
      <div className="flex w-full gap-4 ">
        <Button
          type="primary"
          htmlType="submit"
          block
          onClick={() => DeleteProgram(isModalDeleteOpen)}
          className="bg-[#C43535]"
          loading={isLoading}
        >
          <FormattedMessage id="confirm.yesDeleteProgram" />
        </Button>
        <Button onClick={close} type="default" htmlType="button" block>
          {intl.formatMessage({
            id: "cancel",
            defaultMessage: "إالغاء",
          })}
        </Button>
      </div>
    </div>
  );
};

export default ConFirmDeleteProgram;
